import React, { PropsWithChildren } from 'react';
import _get from 'lodash/get';
import { useIntl } from 'react-intl';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';
import { MessageDescriptor } from '../../../util/types';
import { Text } from '@lifeomic/chroma-react/components/Text';
import clsx from 'clsx';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    marginBottom: theme.spacing(2),
    borderRadius: 5,
    width: '100%',
  },
  titleMarginBelow: {
    marginBottom: theme.spacing(1),
  },
  subtitleMargineBelow: {
    marginBottom: theme.spacing(2),
  },
}));

export type SectionClasses = GetClasses<typeof useStyles>;

export interface SectionOwnProps {
  headingIntlMessage: MessageDescriptor;
  subHeadingIntlMessage?: MessageDescriptor;
  subHeadingMessage?: string | any;
  className?: string;
}

export type SectionProps = SectionOwnProps;

const Section = (props: PropsWithChildren<SectionProps>) => {
  const formatMessage = useIntl().formatMessage;
  const classes = useStyles(props);

  const {
    headingIntlMessage,
    subHeadingMessage,
    subHeadingIntlMessage,
    children,
  } = props;

  const hasSubheading = !!subHeadingIntlMessage || !!subHeadingMessage;
  const headingClass = hasSubheading ? null : classes.titleMarginBelow;

  const renderSubHeading = () => {
    if (subHeadingMessage) {
      return subHeadingMessage;
    } else {
      return formatMessage(
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        subHeadingIntlMessage,
        _get(subHeadingIntlMessage, 'values'),
      );
    }
  };

  return (
    <div className={clsx(classes.root, props.className)}>
      {/* @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks. */}
      <Text className={headingClass}>{formatMessage(headingIntlMessage)}</Text>
      {hasSubheading && (
        <Text className={classes.subtitleMargineBelow} size="caption">
          {renderSubHeading()}
        </Text>
      )}
      {children}
    </div>
  );
};

export default React.memo(Section);
